import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  reset() {
    this.element.reset()
  }

  submit() {
    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  setValue(event) {
    const value = event.currentTarget.dataset.value
    const targetName = event.currentTarget.dataset.targetInput
    
    // 1. Try finding by target first
    let input = this.inputTargets.find(el => el.name === targetName)
    
    // 2. Fallback to name search
    if (!input) {
      input = this.element.querySelector(`input[name="${targetName}"]`) || 
              this.element.querySelector(`input[name*="[${targetName}]"]`)
    }
    
    if (input) {
      input.value = value
      this.submit()
    }
  }
}
